"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberRangeFilter = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const React = __importStar(require("react"));
const index_js_1 = require("../../../utils/index.js");
const FilterButtonBar_js_1 = require("../FilterButtonBar.js");
const BaseFilter_js_1 = require("../BaseFilter.js");
require("@itwin/itwinui-css/css/table.css");
const index_js_2 = require("../../../LabeledInput/index.js");
const defaultStrings = {
    from: 'From',
    to: 'To',
};
const NumberRangeFilter = (props) => {
    var _a, _b, _c, _d;
    const { column, translatedLabels, setFilter, clearFilter } = props;
    (0, index_js_1.useTheme)();
    const translatedStrings = { ...defaultStrings, ...translatedLabels };
    const [from, setFrom] = React.useState((_b = (_a = column.filterValue) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : '');
    const [to, setTo] = React.useState((_d = (_c = column.filterValue) === null || _c === void 0 ? void 0 : _c[1]) !== null && _d !== void 0 ? _d : '');
    const parseInputValue = (value) => {
        return !value || isNaN(Number(value)) ? undefined : Number(value);
    };
    const onKeyDown = (event) => {
        if (event.altKey) {
            return;
        }
        if (event.key === 'Enter') {
            setFilter([parseInputValue(from), parseInputValue(to)]);
        }
    };
    return (React.createElement(BaseFilter_js_1.BaseFilter, null,
        React.createElement(index_js_2.LabeledInput, { label: translatedStrings.from, value: from, onChange: (e) => setFrom(e.target.value), onKeyDown: onKeyDown, type: 'number', displayStyle: 'inline', setFocus: true }),
        React.createElement(index_js_2.LabeledInput, { label: translatedStrings.to, value: to, onChange: (e) => setTo(e.target.value), type: 'number', displayStyle: 'inline', onKeyDown: onKeyDown }),
        React.createElement(FilterButtonBar_js_1.FilterButtonBar, { setFilter: () => setFilter([parseInputValue(from), parseInputValue(to)]), clearFilter: clearFilter, translatedLabels: translatedLabels })));
};
exports.NumberRangeFilter = NumberRangeFilter;
